module.exports = __webpack_public_path__ + "img/boxgifbroken.ff7141a3.gif";